var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { createTransformer } from 'mobx-utils';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { flatten, uniq } from '../../../../utils/helper/lodash_replacements';
export class ExportingTreeSearch {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get exportingTree() {
        return this.parent;
    }
    get actor() {
        return this.exportingTree.actor;
    }
    get allTraitsOfKey() {
        return createTransformer((traitKey) => {
            return uniq(flatten(this.exportingTree.allExportingAspects.map(aspect => aspect.aspectCollectedSets.allOwnTraitsOfKey(traitKey))));
        });
    }
}
__decorate([
    memoize
], ExportingTreeSearch.prototype, "allTraitsOfKey", null);
